export default __webpack_public_path__ + "static/media/heartbroken.5d167c5c.svg";